// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1nc6p","itemTitle":"ClientEmergencyInfo_itemTitle__3n6QC","itemText":"ClientEmergencyInfo_itemText__1vGAQ"};